import styled from 'styled-components';

export const WidgetGameList = styled.div`
  position: relative;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-grow: 1;
`;
